module.exports = __webpack_public_path__ + "static/media/banner-full2.7b49e2a5.png";